import React from 'react';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import SpAccountManagerDropdown from 'components/dropdowns/SpSalePerson/SpAccountManagerDropdown';
import { Form } from 'react-bootstrap';
import BaseDropdown from 'components/dropdowns/BaseDropdown';
const NewBusinessAnalysisFilter = ({ handleChange, filter }) => {
  const generateFinancialYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = 0; i < 10; i++) {
      const year = currentYear - i;
      years.push({
        display: `${year}/${year + 1}`,
        id: year
      });
    }

    return years;
  };
  return (
    <div style={{ marginBottom: '10px' }}>
      <FalconCardHeader
        title=""
        light
        titleTag="h6"
        startEl={
          <div id="orders-actions" className="d-flex flex-row flex-wrap gap-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: '150px',
                  whiteSpace: 'nowrap',
                  marginRight: '1rem'
                }}
              >
                <Form.Label className="mb-0">Account Manager: </Form.Label>
              </div>
              <div style={{ flex: 1 }}>
                <SpAccountManagerDropdown
                  fieldName="accountManager"
                  handleChange={handleChange}
                  styles={{
                    control: base => ({
                      ...base,
                      width: '150px'
                    })
                  }}
                />
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: '150px',
                  whiteSpace: 'nowrap',
                  marginRight: '1rem'
                }}
              >
                <Form.Label className="mb-0">Financial Year: </Form.Label>
              </div>
              <div style={{ flex: 1 }}>
                <BaseDropdown
                  sources={generateFinancialYears()}
                  fieldName="year"
                  selectedOptions={
                    filter?.year ? filter?.year : new Date().getFullYear()
                  }
                  handleChange={opts => handleChange('year', opts.id)}
                  isMulti={false}
                  styles={{
                    control: base => ({
                      ...base,
                      width: '150px'
                    })
                  }}
                />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

NewBusinessAnalysisFilter.propTypes = {
  handleChange: PropTypes.func,
  filter: PropTypes.object
};

export default NewBusinessAnalysisFilter;
